var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6371 39.2749C30.4824 39.2749 39.2742 30.483 39.2742 19.6377C39.2742 8.79233 30.4824 0.000427246 19.6371 0.000427246C8.79183 0.000427246 0 8.79233 0 19.6377C0 30.483 8.79183 39.2749 19.6371 39.2749Z",
    fill: "#2CA2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3691 13.2946V27.3351C21.3691 28.7009 22.0268 29.7674 22.8689 29.7674C23.4098 29.7674 24.3743 29.8659 24.8076 29.5949C25.0506 29.4428 25.0766 29.385 25.2556 29.1606C25.4646 28.8986 25.732 28.217 25.732 27.6115V13.0734C25.732 12.5389 25.5738 12.0379 25.3681 11.6735C25.3575 11.6547 25.3219 11.5899 25.3197 11.5862C24.7475 10.6181 23.8538 10.8621 22.8689 10.8621C22.0268 10.8621 21.3691 11.9288 21.3691 13.2946Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.543 13.0734V27.5562C13.543 28.1442 13.7225 28.6495 13.9553 29.0433C14.5275 30.0114 15.4211 29.7673 16.406 29.7673C17.2481 29.7673 17.9058 28.7008 17.9058 27.335V13.2945C17.9058 11.9287 17.2481 10.8622 16.406 10.8622C15.4203 10.8622 14.5277 10.6178 13.9553 11.5862C13.7251 11.9757 13.543 12.4861 13.543 13.0734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.7ead1f96436400d4a32460c0895eca9b.svg";
export { ForwardRef as ReactComponent };